module.exports = __webpack_public_path__ + "static/img/header-logo.2aba9365.png";